var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrgentFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66668 8.16667C2.91668 8.16667 2.33334 8.75001 2.33334 8.75001V1.75001C2.33334 1.75001 2.91668 1.16667 4.66668 1.16667C6.41668 1.16667 7.58334 2.33334 9.33334 2.33334C11.0833 2.33334 11.6667 1.75001 11.6667 1.75001V8.75001C11.6667 8.75001 11.0833 9.33334 9.33334 9.33334C7.58334 9.33334 6.41668 8.16667 4.66668 8.16667Z",
    fill: "#F26C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33334 8.75001C2.33334 8.75001 2.91668 8.16667 4.66668 8.16667C6.41668 8.16667 7.58334 9.33334 9.33334 9.33334C11.0833 9.33334 11.6667 8.75001 11.6667 8.75001V1.75001C11.6667 1.75001 11.0833 2.33334 9.33334 2.33334C7.58334 2.33334 6.41668 1.16667 4.66668 1.16667C2.91668 1.16667 2.33334 1.75001 2.33334 1.75001L2.33334 12.8333",
    stroke: "#F26C0C",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgentFlagIcon);
export default __webpack_public_path__ + "static/media/urgent_flag_icon.9b9a78446fe00cf512b22fd545c60bf5.svg";
export { ForwardRef as ReactComponent };